"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./../services/util");
const EventEmitter = require('events');
const WAIT_TO_UNSUB = 1000;
class Subscribable extends EventEmitter {
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    asObject() {
        let returnObj = {};
        let self = this;
        Object.keys(this).forEach(function (key) {
            if (key.substr(0, 1) !== '_') {
                returnObj[key] = self[key];
            }
        });
        return returnObj;
    }
    setDeleted() {
        this.emit('deleted');
    }
    inSet(field, value, noCamel = false) {
        let fixedValue;
        if (!noCamel && typeof value === 'object' && value !== null && !(value instanceof File)) {
            if (!Array.isArray(value)) {
                fixedValue = (0, util_1.camelObject)(value);
            }
            else {
                fixedValue = (0, util_1.camelArray)(value);
            }
        }
        else {
            fixedValue = value;
        }
        this['_' + field] = fixedValue;
        this.emit('updated', field, fixedValue, this);
    }
    checkForSubscription() {
        let listenerCount = this.listenerCount('updated');
        if (listenerCount > 0 && !this.isListening) {
            this.isListening = true;
            this.dataService.resubscribe();
        }
        else if (listenerCount === 0 && this.isListening && !this.subscriptionTimeout) {
            let self = this;
            this.subscriptionTimeout = setTimeout(function () {
                let listenerCount = self.listenerCount('updated');
                if (listenerCount === 0 && self.isListening) {
                    self.isListening = false;
                    self.dataService.resubscribe();
                }
            }, WAIT_TO_UNSUB);
        }
    }
    constructor(dataService, id) {
        super();
        this.typeName = "Unknown";
        this.isListening = false;
        this.API_FIELD = null;
        this.subscriptionTimeout = null;
        this._id = id;
        this.dataService = dataService;
        let self = this;
        this.on('newListener', function (event) {
            if (event === 'updated') {
                setTimeout(function () {
                    self.checkForSubscription();
                });
            }
        });
        this.on('removeListener', function (event) {
            if (event === 'updated') {
                setTimeout(function () {
                    self.checkForSubscription();
                });
            }
        });
    }
}
exports.default = Subscribable;
//# sourceMappingURL=subscribable.js.map